import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/tailwind.css';
import keycloakStore from './security/keycloak';
import { makeServer } from './mirage';
import HTTP from './axios-auth';

// Start Mirage server in development mode
if (process.env.NODE_ENV === 'development') {
  // makeServer();
}

// console.log('registerLoginListener')
keycloakStore
  .registerLoginListener()
  .then(async ({ authenticated }) => {
    // Setup token interceptor to add JWT to all HTTP requests
    // This should be set up regardless of authentication status
    // The interceptor will add the token when available
    //   console.log(authenticated)
    keycloakStore.setupTokenInterceptor(HTTP);

    if (authenticated) {
      keycloakStore.setupUserSession();
    }

    createApp(App).use(router).mount('#app');
  })
  .catch((error) => {
    console.error('Error initializing Keycloak:', error);
  });
